import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Load base URL from .env file
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://hawkeye.api.officebau.com";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor - Attach the Bearer Token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken") || process.env.REACT_APP_AUTH_TOKEN;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    toast.error("Request Error: Something went wrong.");
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
   
      const { status, data } = error.response;

      switch (status) {
        case 400:
          toast.error(data.message || "Invalid request.");
          break;
        case 401:
          toast.warning("Session expired. Please log in again.");
          localStorage.removeItem("authToken");
          window.location.href = "/"; 
          break;
        case 403:
          toast.error("You don't have permission to access this.");
          break;
        case 404:
          toast.info(data.message || "Requested resource not found.");
          break;
        case 500:
          toast.error("Server Error: Please try again later.");
          break;
        default:
          toast.error(data.message || "An unknown error occurred.");
      }
    } else if (error.request) {
      toast.error("Network Error: Please check your internet connection.");
    } else {
      toast.error("Something went wrong: " + error.message);
    }

    return Promise.reject(error); // Allow components to handle errors if needed
  }
);

export default axiosInstance;
